/**
 * lexo-api mijozi. Token localStorage'da; Telegram ichida initData, brauzerda `dev:<id>` (API'da DEV_AUTH=1).
 * Xatolar tashlanadi (ApiError) — chaqiruvchi hal qiladi; `fire()` — javobi kerak bo'lmagan yozuvlar uchun (xato faqat konsolga).
 */
import { getInitData } from './telegram';

export const API_URL: string = (import.meta.env.VITE_API_URL as string | undefined)?.replace(/\/$/, '') ?? 'http://localhost:3000';
const TOKEN_KEY = 'lexo.token';

export class ApiError extends Error {
  status: number;
  constructor(status: number, message: string) { super(message); this.status = status; }
}

let token: string | null = null;
try { token = localStorage.getItem(TOKEN_KEY); } catch { /* ignore */ }

export const hasToken = () => !!token;

async function request<T>(method: string, path: string, body?: unknown, retry = true): Promise<T> {
  const res = await fetch(API_URL + path, {
    method,
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: body === undefined ? undefined : JSON.stringify(body),
  });
  if (res.status === 401 && retry && !path.startsWith('/v1/auth/')) {
    await login();
    return request<T>(method, path, body, false);
  }
  if (res.status === 204) return undefined as T;
  const data = (await res.json().catch(() => ({}))) as { error?: string };
  if (!res.ok) throw new ApiError(res.status, data.error ?? `HTTP ${res.status}`);
  return data as T;
}

export const api = {
  get: <T>(p: string) => request<T>('GET', p),
  post: <T>(p: string, b?: unknown) => request<T>('POST', p, b ?? {}),
  patch: <T>(p: string, b: unknown) => request<T>('PATCH', p, b),
  put: <T>(p: string, b: unknown) => request<T>('PUT', p, b),
  del: <T>(p: string) => request<T>('DELETE', p),
};

/** Yozuv: natija kerak emas, xato konsolga (offline navbat MVP'da yo'q). */
export function fire(p: Promise<unknown>, what = 'api') {
  p.catch((e) => console.warn(`[${what}]`, e instanceof Error ? e.message : e));
}

/** initData → JWT. 401 bo'lsa eski token ham tozalanadi: sessiyasiz ilova ishlamaydi (App → Gate). */
export async function login(): Promise<void> {
  try {
    const r = await request<{ token: string }>('POST', '/v1/auth/telegram', { init_data: getInitData() }, false);
    token = r.token;
    try { localStorage.setItem(TOKEN_KEY, token); } catch { /* ignore */ }
  } catch (e) {
    if (e instanceof ApiError && e.status === 401) { token = null; try { localStorage.removeItem(TOKEN_KEY); } catch { /* ignore */ } }
    throw e;
  }
}
